import { useParams } from 'src/routes/hooks';
import ProductAmountView from 'src/sections/management/product/view/product-amount-view';

export default function ProductAmount() {
  const { id } = useParams();

  return <ProductAmountView id={id!} />;
}
